import { useEffect, useState } from "react";
import { Submitbtn } from '../../../Component';
import DatePicker from '../../../Component/datePicker';
import DropdownWithClear from '../../../Component/dropdownWithClear';
import LabelInput from '../../../Component/labelInput';
import PageTitle from '../../../module/pageTitle';
import BarChart from '../RevenueAnalysis/barchart';
import moment from "moment";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { getSourceWiseRevenueAnalysis } from '../cxoSlice';
import { stockSellingType } from "../../../Utils/dataConstant";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
import AdminTable from "../../../Component/adminTable";
const SellingSourceWiseAnalysis = () => {
    const dispatch: Function = useDispatch<AppDispatch>();
    const [startDate, setStartDate] = useState<any>(
        moment.utc(new Date()).format("YYYY-MM-DD")
    );
    const [endDate, setEndDate] = useState<any>(
        moment.utc(new Date()).format("YYYY-MM-DD")
    );
    const [sellingType, setSellingType] = useState<any>("");
    const [analysisList, setAnalysisList] = useState<any>([]);
    const [xLabel1, setxLabel1] = useState<any>([]);
    const [Graphdata1, setGraphdata1] = useState<any>([]);
    const [totalCount, setTotalCount] = useState<any>(0);
    const onchangeStartDate = (value: any) => {
        setStartDate(value);
    };
    const onchangeEndDate = (value: any) => {
        setEndDate(value);
    };
    const onchangeSellingType = (value: any) => {
        setSellingType(value);
        const postData = {
            startDate: startDate,
            endDate: endDate,
            location: value?.value,
        };
        dispatch(
            getSourceWiseRevenueAnalysis({
                params: postData,
                callback: (res: any) => {
                    setAnalysisList(res?.data);
                },
                errorCallback: () => { },
            })
        );
    };
    useEffect(() => {
        const postData = {
            startDate: startDate,
            endDate: endDate,
        };
        dispatch(
            getSourceWiseRevenueAnalysis({
                params: postData,
                callback: (res: any) => {
                    setAnalysisList(res?.data);
                },
                errorCallback: () => { },
            })
        );

    }, []);

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const postData = {
            startDate: startDate,
            endDate: endDate,
            location: sellingType?.value,
        };
        dispatch(
            getSourceWiseRevenueAnalysis({
                params: postData,
                callback: (res: any) => {
             
                     setAnalysisList(res?.data);
                   xLabel1.length = 0;
                   Graphdata1.length = 0;
                   let count = 0;
                   res?.data?.map((value: any) => {
                    count = count + value?.amount;
                    xLabel1?.push(value?.sourceName);
                    Graphdata1?.push(value?.amount);
                  });
                  setTotalCount(count);
                },
                errorCallback: (error: any) => {
                         dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
                               setTimeout(() => {
                                 dispatch(hideSnackbar());
                               }, 5000);
                 },
            })
        );

    }

    const renderListMode = () => {
        return (
          <AdminTable
            pagename={"SellingSrcAnalysis"}
            tableHead={[
              "S.N",
              "SELLING SOURCE",
              "QUANTITY",
              "TOTAL REVENUE",
              "OVERALL CONTRIBUTION",
            ]}
            tableData={analysisList ? analysisList : []}
            edit={false}
          />
        );
      };
 
    return (
        <div className="panel-content">
            <div className="mb-4">
                <PageTitle name={"SOURCE WISE ANALYSIS"} />
            </div>
            <div className="formDiv">
                <div className="bxshadow p-2 borderRadius mb-4 ">
                    <form onSubmit={handleSubmit}>
                        <div className="row ">
                            <div className="col-md-3 mb-3">
                                <LabelInput labelName={"Start Date"} isRequired />
                                <DatePicker
                                    setInputText={(value: any) => {
                                        onchangeStartDate(value);
                                    }}
                                    value={startDate}
                                />
                            </div>
                            <div className="col-md-3 mb-3">
                                <LabelInput labelName={"End Date"} isRequired />
                                <DatePicker
                                    setInputText={(value: any) => {
                                        onchangeEndDate(value);
                                    }}
                                    value={endDate}
                                />
                            </div>
                            <div className="col-md-3 mb-3">
                                <LabelInput labelName={"Seeling Type"} />
                                <DropdownWithClear
                                    labelName={"Select Seeling Type"}
                                    setInputText={(value: any) => onchangeSellingType(value)}
                                    options={stockSellingType}
                                    value={sellingType}
                                />
                            </div>
                            {/* <div className="mt-4">{renderTable()}</div> */}
                        </div>
                        <div className="col-md-2 mx-auto mt-3">
                            <Submitbtn name={"Submit"} />
                        </div>
                    </form>
                    <div className="p-2 bxshadow borderRadius mb-4 mt-5">
                         <BarChart label={xLabel1} value={Graphdata1} />
                    </div>
                    <div className="p-3 bxshadow borderRadius">
                        <h5 className="mb-0 fw-bold">
                            Total Revenue: {"\u20B9"} {totalCount}
                        </h5>
                    </div>
                    <div className="p-3 bxshadow borderRadius mt-4">
                       {renderListMode()}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SellingSourceWiseAnalysis;